import Swal from 'sweetalert2';
import type { PaymentLink, PaymentLinkStatus } from '@masonic-tools/shared-types';
import { callableErrorInfo, setPaymentLinkStatus } from '@/lib/payment-links-api';
import { showError, showSuccess } from '@/lib/swal';

const COPY: Record<PaymentLinkStatus, { title: string; text: string; confirm: string; done: string }> = {
  disabled: {
    title: 'Disable this payment link?',
    text: 'Payers will see "no longer accepting payments". You can enable it again at any time.',
    confirm: 'Disable',
    done: 'Payment link disabled',
  },
  active: {
    title: 'Enable this payment link?',
    text: 'Payers will be able to pay again straight away.',
    confirm: 'Enable',
    done: 'Payment link enabled',
  },
  archived: {
    title: 'Archive this payment link?',
    text: 'It stops taking payments and is hidden from the list. Its payments and exports are kept.',
    confirm: 'Archive',
    done: 'Payment link archived',
  },
};

/** Confirm, then change a link's status. Returns true when changed. */
export async function confirmAndSetLinkStatus(link: PaymentLink, status: PaymentLinkStatus): Promise<boolean> {
  const c = COPY[status];
  const result = await Swal.fire({
    title: c.title,
    text: c.text,
    icon: status === 'active' ? 'question' : 'warning',
    showCancelButton: true,
    confirmButtonText: c.confirm,
    cancelButtonText: 'Cancel',
    confirmButtonColor: status === 'active' ? '#1E3A5F' : '#dc2626',
  });
  if (!result.isConfirmed) return false;
  try {
    await setPaymentLinkStatus({ unitId: link.unitId, linkId: link.id, status });
    showSuccess(c.done);
    return true;
  } catch (e) {
    showError(callableErrorInfo(e, 'Could not change the payment link').message);
    return false;
  }
}
